/* ============================================================
   FHL GO — Venezuela Page Script
   • Language toggle
   • Reveal animation
   • Venezuela Air + Sea Calculator
   • Footer padding fix
============================================================ */

/* ===== i18n – Venezuela page ===== */
const I18N = {
  en: {
    toggleLabel: "EN | ES",

    // Header / crumbs
    crumbHome: "Home",
    crumbPe: "Peru Shipping",
    crumbVe: "Venezuela Shipping",
    crumbCr: "Costa Rica Shipping",
    crumbStores: "Stores",
     crumbAbout: "About Us",
    crumbServices: "Services",
    crumbBlog: "Blog",
    crumbTerms: "Terms of Service",
    crumbPrivacy: "Privacy Policy",
    crumbRefunds: "Refund Policy",

    // Hero
    title1: "Ship to Venezuela— ",
    title2: "Door-to-Door",
    intro:
      "Reliable, streamlined shipping — from any U.S. address to our Miami hub, delivered across Venezuela.",
    ctaShip:   "Start a shipment",
    ctaCalc:   "Open calculator",
    ctaStores: "Popular US stores",
    // How it works
    howTitle: "How it works",
    s1: "Shop at any US store.",
    s2: "Ship your items to our Miami address or drop them off:",
    copiedLabel: "Copied!",
    s3: "Email your shopping list (links, sizes/colors, quantities).",
    s4: "We consolidate and prepare your shipment.",
    s5: "Door-to-door delivery in Venezuela.",
    shopView: "Popular US stores",
    shopEmail: "Email your list",

    // WhatsApp label
    whLead: "Questions? WhatsApp Daniela Tabares:",

    // Locker
    lockTitle: "Miami warehouse / locker",
    lockL1: "Address: 8035 NW 68th St, Miami, FL 33166",
    lockL2: "Drop-off hours: Mon–Fri 9am-5pm",
    lockL3: "We’ll notify you when items arrive and can consolidate by request.",

    // Schedules
    faqTitle: "Schedules & transit",
    schedAir: "Air:",
    airSched: "Departures every Friday",
    airTransit: "3–5 days in transit",
    schedSea: "Sea:",
    seaSched: "Weekly departures",
    seaTransit: "~4 weeks in transit",

    // Sidebar
    sideTitle: "Start shipping",
    sideP: "Start your door-to-door shipping, hassle-free.",

    // Calculator
    estTitle: "Estimated total",
    mAir: "Air (Weight vs Volume)",
    mSea: "Sea (Cubic FT)",
    fWeight: "Actual weight (lb)",
    fValue: "Declared value (USD)",
    fL: "Length (in)",
    fW: "Width (in)",
    fH: "Height (in)",
    btnCalc: "Calculate",
    estDisclaimer: "Estimate only. Duties/taxes & certain fees not included.",
    rateHead: "Venezuela rates:",
    rateAir:
      "Air — $7/lb (chargeable = max actual vs volumetric L×W×H÷166), minimum 5 lb, minimum charge $40.",
    rateSea:
      "Sea — $37 per cubic foot (L×W×H÷1728), minimum 1 cu ft.",
    schedNote:
      "Air departs Fridays (3–5 days). Sea weekly (~4 weeks).",

      followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
  },

  

  es: {
    toggleLabel: "ES | EN",

    // Header / crumbs
    crumbHome: "Inicio",
    crumbPe: "Envíos a Perú",
    crumbVe: "Envíos a Venezuela",
    crumbCr: "Envíos a Costa Rica",
    crumbStores: "Tiendas",
    crumbAbout: "Quiénes somos",
    crumbServices: "Servicios",
    crumbBlog: "Blog",
    crumbTerms: "Términos del servicio",
    crumbPrivacy: "Política de privacidad",
    crumbRefunds: "Política de reembolsos",


    // Hero
    title1: "Envíos a Venezuela —",
    title2: "Puerta a Puerta",
    intro:
      "Envíos confiables y sin complicaciones — desde cualquier parte de EE. UU. a nuestro centro en Miami, entregado a cualquier destino en Venezuela.",
    ctaShip:   "Crear un envío",
    ctaCalc:   "Abrir calculadora",
    ctaStores: "Tiendas populares",
    // How it works
    howTitle: "Cómo funciona",
    s1: "Compra en cualquier tienda de EE. UU.",
    s2: "Envía tus artículos a nuestra dirección en Miami o entrégalos en persona:",
    copiedLabel: "¡Copiado!",
    s3: "Envíanos por email tu lista de compras (enlaces, tallas/colores, cantidades).",
    s4: "Consolidamos y preparamos tu envío.",
    s5: "Entrega puerta a puerta en Venezuela.",
    shopView: "Tiendas populares de EE. UU.",
    shopEmail: "Envíanos tu lista",

    whLead: "¿Dudas? WhatsApp Daniela Tabares:",

    lockTitle: "Bodega / casillero en Miami",
    lockL1: "Dirección: 8035 NW 68th St, Miami, FL 33166",
    lockL2: "Horario de recepción: Lun–Vie 9am-5pm",
    lockL3: "Te avisamos cuando llegue tu compra y podemos consolidar a pedido.",

    faqTitle: "Salidas y tránsito",
    schedAir: "Aéreo:",
    airSched: "Salidas todos los viernes",
    airTransit: "3–5 días en tránsito",
    schedSea: "Marítimo:",
    seaSched: "Salidas semanales",
    seaTransit: "~4 semanas en tránsito",

    sideTitle: "Comenzar envío",
    sideP: "Comienza tu envío puerta a puerta sin complicaciones.",

    estTitle: "Total estimado",
    mAir: "Aéreo (Peso vs Volumen)",
    mSea: "Marítimo (Pies cúbicos)",
    fWeight: "Peso real (lb)",
    fValue: "Valor declarado (USD)",
    fL: "Largo (pulg)",
    fW: "Ancho (pulg)",
    fH: "Alto (pulg)",
    btnCalc: "Calcular",
    estDisclaimer:
      "Este es un estimado. No incluye aranceles, impuestos u otros cargos.",
    rateHead: "Tarifas Venezuela:",
    rateAir:
      "Aéreo — $7/lb (peso facturable = mayor entre peso real y volumétrico L×W×H÷166), mínimo 5 lb, cobro mínimo $40.",
    rateSea:
      "Marítimo — $37 por pie cúbico (L×W×H÷1728), mínimo 1 pie cúbico.",
    schedNote:
      "Aéreo sale los viernes (3–5 días). Marítimo semanal (~4 semanas).",

      followTitle: "SÍGUENOS",
    companyTitle: "COMPAÑÍA",
    legalTitle: "INFO LEGAL",
    lnkAbout: "Quiénes somos",
    lnkServices: "Servicios",
    lnkBlog: "Blog",
    lnkTerms: "Términos del servicio",
    lnkPrivacy: "Política de privacidad",
    lnkRefunds: "Política de reembolsos",
    copyright: "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
  
  }
};

/* ---------- Apply language ---------- */
function applyLang(lang) {
  const d = I18N[lang] || I18N.en;

  // Update document title
  document.title =
    lang === "es"
      ? "FHL GO — Envíos a Venezuela"
      : "FHL GO — Ship to Venezuela";

  // Generic text nodes
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    if (!key || d[key] === undefined) return;

    if (key === "title") {
      el.innerHTML = d[key];
    } else {
      el.textContent = d[key];
    }
  });

  const toggle = document.getElementById("lang");
  if (toggle) toggle.textContent = d.toggleLabel;

  localStorage.setItem("fhl_lang", lang);
}

/* Init + click handler */
(() => {
  const initial = localStorage.getItem("fhl_lang") || "en";
  applyLang(initial);

  const toggle = document.getElementById("lang");
  if (toggle) {
    toggle.addEventListener("click", () => {
      const cur = localStorage.getItem("fhl_lang") || "en";
      const next = cur === "en" ? "es" : "en";
      applyLang(next);
    });
  }
})();

/* ---------- Reveal animation ---------- */
(() => {
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  )
    return;

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
  );

  document.querySelectorAll("[data-reveal]").forEach((el) => io.observe(el));
})();

/* ============================================================
   Calculator logic for Venezuela country page (VE)
============================================================ */

// ----- CONFIG -----
const RATES_VE = {
  AIR_RATE_PER_LB: 7,        // $7 per lb
  AIR_DIM_DIV: 166,          // volumetric divisor (lb)
  AIR_MIN_LB: 5,             // minimum billable weight
  AIR_MIN_CHARGE: 40,        // minimum air charge in USD
  SEA_RATE_PER_CUFT: 37,     // $37 per cubic foot
  SEA_MIN_CUFT: 1            // minimum cubic feet
};

// ------ SMALL HELPERS ------
function veGetLang() {
  const lang = (localStorage.getItem("fhl_lang") || "en").toLowerCase();
  return lang === "es" ? "es" : "en";
}

function veText(key) {
  const lang = veGetLang();
  const dict = {
    en: {
      airLabel: "Air (Weight vs Volume)",
      seaLabel: "Sea (Cubic FT)",
      estTitle: "Estimated total",
      missing: "Please enter at least weight and dimensions.",
      airLine1: (w, vol) =>
        `Air: Actual weight = ${w.toFixed(2)} lb · Volumetric = ${vol.toFixed(
          2
        )} lb`,
      airLine2: (charged) =>
        `Chargeable weight: ${charged.toFixed(
          2
        )} lb @ $${RATES_VE.AIR_RATE_PER_LB.toFixed(
          2
        )}/lb (min ${RATES_VE.AIR_MIN_LB} lb, min $${RATES_VE.AIR_MIN_CHARGE.toFixed(
          2
        )})`,
      airMin: () =>
        `Minimum charge applied: $${RATES_VE.AIR_MIN_CHARGE.toFixed(2)}`,
      seaLine1: (cuft) => `Sea: Volume = ${cuft.toFixed(2)} ft³`,
      seaLine2: (billed) =>
        `Billed volume: ${billed.toFixed(
          2
        )} ft³ @ $${RATES_VE.SEA_RATE_PER_CUFT.toFixed(
          2
        )}/ft³ (min ${RATES_VE.SEA_MIN_CUFT} ft³)`,
      decLine: (decl) => `Declared value (USD): $${decl.toFixed(2)}`,
      modeAir: "Mode: Air (Weight vs Volume)",
      modeSea: "Mode: Sea (Cubic FT)"
    },
    es: {
      airLabel: "Aéreo (Peso vs Volumen)",
      seaLabel: "Marítimo (Pies³)",
      estTitle: "Total estimado",
      missing: "Ingresa al menos el peso y las dimensiones.",
      airLine1: (w, vol) =>
        `Aéreo: Peso real = ${w.toFixed(2)} lb · Volumétrico = ${vol.toFixed(
          2
        )} lb`,
      airLine2: (charged) =>
        `Peso cobrable: ${charged.toFixed(
          2
        )} lb a $${RATES_VE.AIR_RATE_PER_LB.toFixed(
          2
        )}/lb (mín ${RATES_VE.AIR_MIN_LB} lb, mín $${RATES_VE.AIR_MIN_CHARGE.toFixed(
          2
        )})`,
      airMin: () =>
        `Se aplicó el cargo mínimo: $${RATES_VE.AIR_MIN_CHARGE.toFixed(2)}`,
      seaLine1: (cuft) => `Marítimo: Volumen = ${cuft.toFixed(2)} ft³`,
      seaLine2: (billed) =>
        `Volumen facturable: ${billed.toFixed(
          2
        )} ft³ a $${RATES_VE.SEA_RATE_PER_CUFT.toFixed(
          2
        )}/ft³ (mín ${RATES_VE.SEA_MIN_CUFT} ft³)`,
      decLine: (decl) => `Valor declarado (USD): US$ ${decl.toFixed(2)}`,
      modeAir: "Modo: Aéreo (Peso vs Volumen)",
      modeSea: "Modo: Marítimo (Pies cúbicos)"
    }
  };

  const d = dict[lang] || dict.en;
  return d[key];
}

// ----- MAIN CALCULATOR IIFE -----
(function initVenezuelaCalculator() {
  const calcBtn = document.getElementById("calcBtn");
  const out = document.getElementById("estOut");
  const total = document.getElementById("estTotal");
  const box = document.querySelector(".est-result"); // orange box wrapper (if present)

  // If this page has no calculator, bail out quietly.
  if (!calcBtn || !out || !total) return;

  const $ = (id) => document.getElementById(id);
  const getMode = () =>
    document.querySelector('input[name="mode"]:checked')?.value || "air";

  calcBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const w = parseFloat($("w")?.value || "0") || 0;       // actual weight (lb)
    const decl = parseFloat($("decl")?.value || "0") || 0; // declared value
    const L = parseFloat($("l")?.value || "0") || 0;       // length (in)
    const W = parseFloat($("w2")?.value || "0") || 0;      // width (in)
    const H = parseFloat($("h")?.value || "0") || 0;       // height (in)

    const mode = getMode();

    // Need *something* to calculate
    if (!L && !W && !H && !w) {
      if (box) box.style.display = "none";
      out.style.display = "block";
      total.style.display = "none";
      out.textContent = veText("missing");
      total.textContent = "";
      return;
    }

    let lines = [];
    let totalUSD = 0;

    if (mode === "air") {
      const volLb = (L * W * H) / RATES_VE.AIR_DIM_DIV || 0;
      const chargeable = Math.max(w, volLb, 0);
      const billedLb = Math.max(chargeable, RATES_VE.AIR_MIN_LB);
      const base = billedLb * RATES_VE.AIR_RATE_PER_LB;

      totalUSD = Math.max(base, RATES_VE.AIR_MIN_CHARGE);

      lines.push(veText("modeAir"));
      lines.push(veText("airLine1")(w, volLb));
      lines.push(veText("airLine2")(billedLb));
      lines.push(veText("decLine")(decl)); // declared value line
      if (totalUSD === RATES_VE.AIR_MIN_CHARGE) {
        lines.push(veText("airMin")());
      }
    } else {
      const cuft = (L * W * H) / 1728 || 0;
      const billedCuFt = Math.max(cuft, RATES_VE.SEA_MIN_CUFT);
      totalUSD = billedCuFt * RATES_VE.SEA_RATE_PER_CUFT;

      lines.push(veText("modeSea"));
      lines.push(veText("seaLine1")(cuft));
      lines.push(veText("seaLine2")(billedCuFt));
      lines.push(veText("decLine")(decl)); // declared value line
    }

    // Show results in orange box style (if it exists)
    if (box) box.style.display = "block";

    out.style.display = "block";
    total.style.display = "block";

    out.innerHTML = lines.join("<br>");
    const label = veText("estTitle");
    total.textContent = `${label}: $${totalUSD.toFixed(2)}`;
  });
})();

/* ---------- Footer padding fix ---------- */
(() => {
  const footer = document.getElementById("siteFooter");

  function pad() {
    document.body.style.paddingBottom = (footer?.offsetHeight || 0) + "px";
  }

  window.addEventListener("load", pad);
  window.addEventListener("resize", () => setTimeout(pad, 50));
})();

/* ---------- Copy Miami address helper ---------- */
window.copyFHLAddress = function () {
  const icon = document.getElementById("fhlgo-copy-address");
  const confirm = document.getElementById("copy-confirm");
  if (!icon || !confirm) return;

  const text = icon.dataset.address || "8035 NE 68th St, Miami, FL 33166";

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(
      () => {
        confirm.style.display = "inline";
        setTimeout(() => {
          confirm.style.display = "none";
        }, 1500);
      },
      () => fallbackCopy(text, confirm)
    );
  } else {
    fallbackCopy(text, confirm);
  }
};

function fallbackCopy(text, confirmEl) {
  const temp = document.createElement("textarea");
  temp.value = text;
  temp.style.position = "fixed";
  temp.style.opacity = "0";
  document.body.appendChild(temp);
  temp.select();
  try {
    document.execCommand("copy");
  } catch (e) {}
  document.body.removeChild(temp);

  confirmEl.style.display = "inline";
  setTimeout(() => {
    confirmEl.style.display = "none";
  }, 1500);
}